import { render, staticRenderFns } from "./viewControl.vue?vue&type=template&id=1c5b15a9&"
import script from "./viewControl.vue?vue&type=script&lang=js&"
export * from "./viewControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports